module.exports = __webpack_public_path__ + "img/img37.edace570.svg";